import { render, staticRenderFns } from "./MainInput.vue?vue&type=template&id=54a5ac00&scoped=true"
import script from "./MainInput.vue?vue&type=script&lang=js"
export * from "./MainInput.vue?vue&type=script&lang=js"
import style0 from "./MainInput.vue?vue&type=style&index=0&id=54a5ac00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a5ac00",
  null
  
)

export default component.exports